import React, { FC, useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { AnyAction } from 'redux'
import {
    Drawer,
    Form,
    Button,
    Col,
    Row,
    Input,
    Space,
    Divider,
    Select
} from 'antd'
import { toast } from 'react-toastify'
import PrefixService from "../../../services/prefix"
import { requestAuthInit } from '../../../store/auth/auth.actions'
import { AddBankParams } from '../../../@types/prefix'
import { ThunkDispatch } from '../../../@types/store'
import PatternNumber from '../../../utils/PatternNumber'
import { FuncFormattedMessage } from '../../../utils/FuncFormattedMessage'
import FormattedMessage from '../../Elements/FormattedMessage'

interface AddBankProps {
    close: () => void
    isOpen: boolean
}

const AddBank: FC<AddBankProps> = ({ close, isOpen }) => {
    const [form] = Form.useForm();
    const title = FuncFormattedMessage("banks.add", "เพิ่มบัญชีธนาคาร")
    const { Option } = Select
    const [btnLoading, setBtnLoading] = useState(false)
    const dispatch: ThunkDispatch<AnyAction> = useDispatch()

    const insertData = async (values: AddBankParams) => {
        try {
            const res = await PrefixService.addBankAccount(values)
            setBtnLoading(false)
            dispatch(requestAuthInit(false))
            toast.success(res.message)
            close()
        } catch ({ message }) {
            toast.error(message as string)
            setBtnLoading(false)
        }
    }

    const handleFormSubmit = () => {
        form.validateFields()
            .then((values: AddBankParams) => {
                setBtnLoading(true)
                insertData(values)
            })
            .catch((errorInfo) => { });
    };


    useEffect(() => {
        if (form && isOpen) {
            form.resetFields();
        }
    }, [form, isOpen]);

    const text_accountName = FuncFormattedMessage("banks.input.accountName", "ชื่อบัญชี")
    const text_accountNumber = FuncFormattedMessage("banks.input.accountNumber", "เลขบัญชี")
    const text_bank = FuncFormattedMessage("banks.input.bank", "ธนาคาร")
    const text_select_bank = FuncFormattedMessage("banks.input.select_bank", "เลือกธนาคาร")

    return (
        <>
            <Drawer
                title={title}
                onClose={close}
                visible={isOpen}
                bodyStyle={{ paddingBottom: 80 }}
                width={global.window.innerWidth <= 1200 ? global.window.innerWidth : global.window.innerWidth * .4}
                extra={
                    <Space>
                        <Button
                            onClick={handleFormSubmit}
                            type="primary"
                            loading={btnLoading}
                            size="large">
                            <i className="fa-solid fa-save me-2"></i>
                            <FormattedMessage id="save" defaultMessage="บันทึก" />
                        </Button>
                    </Space>
                }>
                <Form
                    form={form}
                    name="AddBank"
                    layout="vertical"
                    hideRequiredMark>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                name="accountName"
                                label={text_accountName}
                                rules={[{ required: true, message: <FormattedMessage id="banks.input.please_accountName" defaultMessage="กรุณากรอกชื่อบัญชี" /> }]}
                                hasFeedback>
                                <Input placeholder={text_accountName} />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                name="accountNumber"
                                label={text_accountNumber}
                                rules={[
                                    { required: true, message: <FormattedMessage id="banks.input.please_accountNumber" defaultMessage="กรุณากรอกเลขที่บัญชี" /> },
                                    { pattern: PatternNumber, message: <FormattedMessage id="please-enter-numbers-only" defaultMessage="กรุณากรอกเป็นตัวเลขเท่านั้น" /> }
                                ]}
                                hasFeedback>
                                <Input placeholder={text_accountNumber} inputMode='numeric' />
                            </Form.Item>
                        </Col>
                    </Row>
                    <Row gutter={16}>
                        <Col span={24}>
                            <Form.Item
                                name="bank"
                                label={text_bank}
                                rules={[{ required: true, message: <FormattedMessage id="banks.input.please_select_bank" defaultMessage="กรุณาเลือกธนาคาร" /> }]}
                                hasFeedback>
                                <Select
                                    placeholder={text_select_bank}
                                    showSearch
                                    optionFilterProp="children"
                                    filterOption={(input: any, option: any) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }>
                                    <Option key={'scb'} value={'scb'}><FormattedMessage id="banks.input.option_banks.scb" defaultMessage="ธนาคารไทยพาณิชย์" /></Option>
                                    <Option key={'kbank'} value={'kbank'}><FormattedMessage id="banks.input.option_banks.kbank" defaultMessage="ธนาคารกสิกรไทย" /></Option>
                                    {/* <Option key={'bay'} value={'bay'}><FormattedMessage id="banks.input.option_banks.bay" defaultMessage="ธนาคารกรุงศรีอยุธยา" /></Option> */}
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                    <Divider />
                    <div className="drawer-actions">
                        <Space>
                            <Button type="primary" htmlType="submit" disabled={btnLoading} onClick={handleFormSubmit} size="large">
                                <i className="fa-solid fa-save me-2"></i> <FormattedMessage id="save" defaultMessage="บันทึก" />
                            </Button>
                            <Button onClick={close} size="large">
                                <FormattedMessage id="cancel" defaultMessage="ยกเลิก" />
                            </Button>
                        </Space>
                    </div>
                </Form>
            </Drawer>
        </>
    )
}
export default AddBank

